import PageHero from '@/components/site/PageHero';
import SectionHeading from '@/components/site/SectionHeading';
import CtaBand from '@/components/site/CtaBand';
import CheckList from '@/components/sections/CheckList';
import SpotlightCards from '@/components/ui/SpotlightCards';
import Reveal from '@/components/ui/Reveal';
import { usePage } from '@site/content';

export default function Amc() {
  const { hero, intro, highlights, coverage } = usePage('amc');
  return (
    <>
      <PageHero {...hero} seoTitle="Annual Maintenance Contracts (AMC)" />

      <section className="py-16 sm:py-24">
        <div className="site-container grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <img src={intro.image} alt={intro.imageAlt} loading="lazy" className="aspect-[4/3] w-full rounded-[2rem] object-cover" />
          </Reveal>
          <div>
            <SectionHeading eyebrow={intro.eyebrow} title={intro.title} />
            <p className="mt-5 text-pretty leading-relaxed text-ink-600">{intro.paragraph1}</p>
            <p className="mt-4 text-pretty leading-relaxed text-ink-600">{intro.paragraph2}</p>
          </div>
        </div>
      </section>

      <section className="bg-ink-50 py-16 sm:py-24">
        <div className="site-container">
          <SpotlightCards columns={4} items={highlights} />
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={coverage.eyebrow} title={coverage.title} />
          <div className="mt-8">
            <CheckList items={coverage.items} />
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
